const translations: Record<string, string> = {
    application: 'Application',
    battery: 'Battery',
    battery_other: 'Batteries',
    boundary: 'Boundary',
    boundary_other: 'Boundaries',
    city: 'City',
    client: 'Client',
    contactName: 'Contact Name',
    controllerSerialNumber: 'Cntlr. S/N',
    drone: 'Drone',
    drone_other: 'Drones',
    droneSerialNumber: 'Drone S/N',
    email: 'Email',
    estimatedAcres: 'Est. Acres',
    faaRegistrationNumber: 'FAA REG #',
    farm: 'Farm',
    field: 'Field',
    field_other: 'Fields',
    flightControllerFirmwareVersion: 'Firmware',
    flightHours: 'Flight Hrs',
    numberOfFlights: 'Flights',
    phone: 'Phone',
    pilot: 'Pilot',
    pilot_other: 'Pilots',
    primaryBoundary: 'Primary Boundary',
    role: 'Role',
    scheduledPilot: 'Scheduled Pilot',
    scheduledPilot_other: 'Scheduled Pilots',
    serialNumber: 'BATT S/N',
    state: 'State',
    status: 'Status',
    totalAcres: 'T. Acres',
    totalAreaApplied: 'Area Applied',
    totalVolumeApplied: 'Volume Applied',
    user: 'User',
    warrantyEndDate: 'Wty. End',
    warrantyRemaining: 'Wty. Rmng',
    warrantyStartDate: 'Wty. Start',
    zip: 'ZIP'
};

export default translations;
